import React from 'react';
import PropTypes from 'prop-types';

const DefaultLoadingComponent = ({ backgroundColor, fixedHeightPxs, fixedHeightPerc }) => {
	let height = '100%';
	if (fixedHeightPxs) {
		height = `${fixedHeightPxs}px`;
	} else if (fixedHeightPerc) {
		height = `${fixedHeightPerc}%`;
	}
	return (
		<div
			style={{
				width: '100%',
				height,
				backgroundColor,
			}}>
			<h1 className='card-title ekho-placeholder-wave h1'>
				<span className='ekho-placeholder col-6' />
			</h1>
			<br />
			<br />
			<div className='p-0 ekho-placeholder-wave' style={{ height: '5vh' }}>
				<span className='ekho-placeholder col-12 h-100' />
			</div>
			<br />
			<br />
			<h2 className='card-title ekho-placeholder-wave'>
				<span className='ekho-placeholder col-10' />
			</h2>
			<br />
			<br />
			<div className='p-0 ekho-placeholder-wave' style={{ height: '8vh' }}>
				<span className='ekho-placeholder col-12 h-100' />
			</div>
			<br />
			<br />
			<h2 className='card-title ekho-placeholder-wave'>
				<span className='ekho-placeholder col-4' />
			</h2>
			<br />
			<br />
			<div className='p-0 ekho-placeholder-wave' style={{ height: '12vh' }}>
				<span className='ekho-placeholder col-12 h-100' />
			</div>
		</div>
	);
};

DefaultLoadingComponent.propTypes = {
	backgroundColor: PropTypes.string,
	fixedHeightPxs: PropTypes.number,
	fixedHeightPerc: PropTypes.number,
};
DefaultLoadingComponent.defaultProps = {
	backgroundColor: 'transparent',
	fixedHeightPxs: null,
	fixedHeightPerc: null,
};

export default DefaultLoadingComponent;
